<template>
  <page-header-wrapper>
    <!-- :include="this.cachedViews" -->
    <keep-alive >
      <router-view />
    </keep-alive>
  </page-header-wrapper>
</template>

<script>

export default {
  name: 'PageView',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    }
  }
}
</script>
